<header
  class="sticky top-0 z-99999 flex w-full border-b border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900"
>
  <div class="flex grow items-center justify-between gap-3 px-3 py-3 sm:px-5 lg:py-4 xl:px-6">
    <div class="flex min-w-0 items-center gap-3">
      <img class="h-10 w-10 shrink-0 object-contain" src="./assets/logo.png" alt="Logo" />
      <div class="min-w-0">
        <div class="truncate text-xl font-semibold text-gray-800 dark:text-white/90 sm:text-2xl">Supplier System</div>
      </div>
    </div>

    <div class="flex items-center gap-2">
      <app-theme-toggle-button />
      <app-user-dropdown />
    </div>
  </div>
</header>
